import { useRefinementList } from 'react-instantsearch';
import type { RefinementListProps } from 'react-instantsearch';

export function VirtualRefinementList(props: RefinementListProps) {
  useRefinementList(props);

  return null;
}
